import React from 'react';
import { Check, Users, Building2, Building } from 'lucide-react';
interface PricingSectionProps {
  setIsFormOpen: (isOpen: boolean) => void;
}
export const PricingSection = ({
  setIsFormOpen
}: PricingSectionProps) => {
  const plans = [{
    name: 'Individual/Small Business',
    price: '$9.99',
    icon: <Users className="h-8 w-8 text-indigo-600" data-id="element-285" />,
    description: 'Perfect for individuals and small teams',
    features: ['Up to 5 users', '24/7 AI support', 'Windows & MacOS support', 'Basic troubleshooting', 'Email support']
  }, {
    name: 'Medium Business',
    price: '$14.99',
    icon: <Building2 className="h-8 w-8 text-indigo-600" data-id="element-286" />,
    description: 'Ideal for growing businesses',
    features: ['Up to 50 users', '24/7 AI support', 'Windows & MacOS support', 'Advanced troubleshooting', 'Performance optimization', 'ITSM integration (basic)', 'Priority email support', 'Monthly reports'],
    popular: true
  }, {
    name: 'Enterprise',
    price: '$19.99',
    icon: <Building className="h-8 w-8 text-indigo-600" data-id="element-287" />,
    description: 'Complete solution for large organizations',
    features: ['Unlimited users', '24/7 AI support', 'Windows & MacOS support', 'Advanced troubleshooting', 'Performance optimization', 'Full ITSM integration', 'ServiceNow, Zendesk, Freshdesk APIs', 'Preventative maintenance', 'Custom automation workflows', 'Dedicated account manager', 'Priority phone & email support', 'Advanced analytics & reporting', 'Custom SLA agreements', 'On-premise deployment option']
  }];
  return <section id="pricing" className="py-20 px-4 bg-slate-50" data-id="element-288">
      <div className="max-w-7xl mx-auto" data-id="element-289">
        <div className="text-center mb-16" data-id="element-290">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-291">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-292">
            Choose the plan that fits your needs. All plans include our core AI
            support features.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-293">
          {plans.map((plan, index) => <div key={index} className={`bg-white rounded-xl p-8 ${plan.popular ? 'ring-2 ring-indigo-600 shadow-xl relative' : 'border border-slate-200 shadow-md'}`} data-id="element-294">
              {plan.popular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-295">
                  <span className="bg-indigo-600 text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-296">
                    Most Popular
                  </span>
                </div>}

              <div className="flex items-center justify-center mb-4" data-id="element-297">
                {plan.icon}
              </div>

              <h3 className="text-2xl font-bold text-gray-900 text-center mb-2" data-id="element-298">
                {plan.name}
              </h3>

              <p className="text-gray-600 text-center mb-6" data-id="element-299">
                {plan.description}
              </p>

              <div className="text-center mb-6" data-id="element-300">
                <span className="text-4xl font-bold text-gray-900" data-id="element-301">
                  {plan.price}
                </span>
                <span className="text-gray-600" data-id="element-302">/user/month</span>
              </div>

              <ul className="space-y-3 mb-8" data-id="element-303">
                {plan.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start gap-3" data-id="element-304">
                    <Check className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" data-id="element-305" />
                    <span className="text-gray-700" data-id="element-306">{feature}</span>
                  </li>)}
              </ul>

              <button onClick={() => setIsFormOpen(true)} className={`w-full py-3 rounded-lg font-medium transition ${plan.popular ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-slate-100 text-gray-900 hover:bg-slate-200'}`} data-id="element-307">
                Get Started
              </button>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-308">
          <p className="text-gray-600" data-id="element-309">
            All plans include a 14-day free trial. No credit card required.
          </p>
        </div>
      </div>
    </section>;
};